import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=ae6ecc4a&scoped=true&"
import script from "./viewDetails.vue?vue&type=script&lang=ts&"
export * from "./viewDetails.vue?vue&type=script&lang=ts&"
import style0 from "./viewDetails.vue?vue&type=style&index=0&id=ae6ecc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6ecc4a",
  null
  
)

export default component.exports